import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Sentry from "../../../api/sentry";

import { ONBOARDING_STEPS, GENERIC_ERROR_MESSAGE, GQL_ERROR } from "../../../constants";

/* Actions */
import { updateToNextStep } from "../../../state/actions";
import { useCurrentStep } from "../../../state/store/customHooks";

import { Title } from "../../common";
import Loading from "../../common/Loading";
import AddressForm from "./AddressForm";
import { UPDATE_ADDRESS_STEP } from "./gql";

const AddressV2 = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [errorNetwork, setErrorNetwork] = useState(null);

  const currentStep = useCurrentStep();
  const readOnlyMode = currentStep !== ONBOARDING_STEPS.Address;

  const [updateAddressStep, { loading: updateAddressStepLoading }] =
    useMutation(UPDATE_ADDRESS_STEP);

  const _completeStep = async (address, bypassVerification) => {
    if (!readOnlyMode) {
      let data;
      try {
        data = await updateAddressStep({
          variables: {
            address,
            skipAddressVerification: bypassVerification,
          },
        });
      } catch (err) {
        Sentry.captureException(err);
        setErrorNetwork(GENERIC_ERROR_MESSAGE);
        return;
      }

      const { updateAddressWithOnboardingStep } = data?.data;
      const { status } = updateAddressWithOnboardingStep;

      if (status === GQL_ERROR) {
        setErrorNetwork(GENERIC_ERROR_MESSAGE);
        return;
      }

      setErrorNetwork(null);
    }

    dispatch(updateToNextStep(history));
  };

  return (
    <>
      {updateAddressStepLoading && <Loading />}
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          <Title
            text="What is your current residential address?"
            disabled={readOnlyMode}
            disabledText="Your address has been verified"
          />
          <AddressForm readOnly={readOnlyMode} _completeStep={_completeStep} />
          {errorNetwork && <div className="errorText">{errorNetwork}</div>}
        </div>
      </div>
    </>
  );
};

export default AddressV2;
